// https://app.growthbook.io/features/mccerts-2972-subs-only-clp-v1
export const MCCERTS_2972_SUBS_ONLY_CLP_FLAG = 'mccerts-2972-subs-only-clp-v1'

export type SubsOnlyClpBucket =
  | 'control'
  | 'variant_1'
  | 'variant_2'
  | 'variant_3'
